/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.0073 4.0213C.1372 1.7786 1.997 0 4.2723 0h8.4535l.2511.0073c2.2426.1299 4.0212 1.9897 4.0212 4.265V7.5H20.25c1.9882 0 3.6151 1.5473 3.742 3.5034L24 11.25v11.8447a.375.375 0 0 1-.5602.3262l-.08-.0611L19.5 19.5h-8.25c-1.9054 0-3.4789-1.421-3.7184-3.2611l-.0236-.2423L7.5 15.75v-2.9787l-2.2124-.0003-3.406 3.4062-.1236.1067c-.4315.3202-1.0438.2846-1.4352-.1067A1.1023 1.1023 0 0 1 0 15.3978V4.2723l.0073-.251ZM7.5 11.2714V11.25c0-1.9882 1.5473-3.615 3.5034-3.742L11.25 7.5h4.2484l-.0003-3.2277-.0083-.2167C15.3793 2.6258 14.184 1.5 12.7258 1.5H4.2723l-.2167.0083C2.6258 1.619 1.5 2.8141 1.5 4.2723l.0001 10.1652 3.166-3.1661H7.5ZM20.25 9h-9c-1.1695 0-2.1307.8923-2.2397 2.0333L9 11.25l-.0008 4.4515.0056.1979c.072 1.1081.9456 1.9911 2.038 2.0912L11.25 18h8.8713L22.5 20.379V11.25c0-1.1695-.8923-2.1307-2.0333-2.2397L20.25 9Z"
    clipRule="evenodd"
  />,
  'Forum'
);
